export default "__VITE_ASSET__BMuGRaDQ__"